import SwitchBoard from './SwitchBoard';
import CircleSwitch from './components/CircleSwitch';
import TextSwitch from './components/TextSwitch';
import BlockSwitch from './components/BlockSwitch';

export default SwitchBoard;
export { CircleSwitch, TextSwitch, BlockSwitch };
